import { useParams } from "react-router-dom";
import { BIUserDetailMainContent } from "./biUserReportDetailComponents/BIUserDetailMainContent";

const BiUserReportDetail = () => {
  const { id } = useParams();
  // Breadcrumbs are set in BIUserDetailMainContent where user data is fetched

  return <BIUserDetailMainContent id={id} />;
};

export default BiUserReportDetail;
